module.exports = __webpack_public_path__ + "792648e7c93411b322e1c4061e248bd2.svg";